import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';
import { updateFiles } from '../../file/updateFiles';
import { uploadSelector } from '../../../utils/pageHelpers';

export function* update({ payload: { companyId, values, sectionKey } }) {
  try {
    const { uploadKeys, ...dirtyValues } = values.emrInfo;
    const formValues = Object.keys(dirtyValues).reduce(
      (acc, item) => (uploadKeys.includes(item) ? acc : { ...acc, [item]: dirtyValues[item] }),
      {},
    );

    // update files
    if (uploadKeys.length) {
      yield all(
        uploadKeys.map(
          key =>
            (values.emrInfo[key].createList.length || values.emrInfo[key].deleteList.length) &&
            call(updateFiles, {
              companyId,
              deleteList: values.emrInfo[key].deleteList,
              createList: values.emrInfo[key].createList,
              sectionKey: key,
            }),
        ),
      );
    }

    const fileObj = yield select(store => uploadSelector(store, uploadKeys));

    const { data } = yield call(dataProvider.updateOnly, `companies/${companyId}/emr`, {
      ...values,
      emrInfo: formValues,
    });

    yield put({
      type: currentCompany.emrate.update.end,
      payload: { emrInfo: { ...data.emrInfo, ...fileObj, uploadKeys }, emrArrays: data.emrs },
    });

    // update PQF document validation
    yield put({
      type: currentCompany.companyInfo.validation.start,
      payload: { companyId: companyId, validationKey: sectionKey },
    });
  } catch (e) {
    yield put({ type: currentCompany.emrate.update.error });
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* getEmrSaga() {
  yield takeLatest(currentCompany.emrate.update.start, update);
}
